export enum Breakpoints {
    SMALL_MIN = 0,
    SMALL_MAX = 768,
    MEDIUM_MIN = 769,
    MEDIUM_MAX = 1024,
    LARGE_MIN = 1025,
    LARGE_MAX = 1380,
    EXTRA_LARGE_MIN = 1381,
    VENDOR = 961,
    VENDOR_INVERSED = 960
}
